﻿// General mixin for shared functionality among Vue instances
const mixin = {
    methods: {
        // Simple capitalize function.
        capitalize(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        // Simple whitespace strip function.
        strip(value) {
            if (!value) return '';
            value = value.toString();
            return value.replace(/\s/g, '');
        },
        // Simple date object handler.
        toDateObj(dateString) {
            if (!dateString) return null;
            return new Date(dateString);
        },
        // Simple date string handler.
        toDateStr(dateString) {
            if (!dateString) return null;
            return new Date(dateString).toLocaleDateString('en-GB', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        },
        // Simple date string handler.
        toShortDateStr(dateString, showYear = false) {
            if (!dateString) return null;
            return new Date(dateString).toLocaleDateString('en-GB', {
                month: 'short',
                weekday: 'short',
                day: 'numeric',
                year: showYear ? 'numeric' : undefined,
            });
        },
        // Date range handler for previewing.
        toDatesStr(startDate = null, endDate = null) {
            if (new Date(startDate).getFullYear() === 1) startDate = null;
            if (new Date(endDate).getFullYear() === 1) endDate = null;
            if (!startDate && !endDate) return '';
            if (startDate && endDate) {
                if (startDate === endDate) {
                    return this.toShortDateStr(startDate, true);
                }
                else {
                    let showYear = new Date(startDate).getFullYear() !== new Date(endDate).getFullYear();
                    return `${this.toShortDateStr(startDate, showYear)} - ${this.toShortDateStr(endDate, true)}`;
                }
            }
            else if (startDate) return this.toShortDateStr(startDate, true);
            else if (endDate) return this.toShortDateStr(endDate, true);
            return '';
        },
        // Simple date string handler to output month and year.
        toMonthYearStr(dateString) {
            if (!dateString) return null;
            const dateParts = dateString.split('-');
            if (dateParts.length > 1) {
                const [month, year] = dateParts;
                const date = new Date(year, month - 1);
                const options = { year: 'numeric', month: 'long' };
                return date.toLocaleDateString('en-GB', options);
            }
            return dateString;
        },
        // Simple array reverser.
        reverse(array) {
            return [...array].reverse();
        },
        // General debounce function for reducing unnecessary API calls.
        debounce(cb, delay = 500) {
            let timeout;
            return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                cb(...args)
            }, delay)}
        },
        // Function to remove duplicates from array.
        removeDuplicatesById(array) {
            return array.reduce((accumulator, current) => {
                if (!accumulator.find((item) => item.id === current.id)) {
                    accumulator.push(current);
                }
                return accumulator;
            }, []);
        },
    }
}

export default mixin;
